import React from "react";

const TextCell = ({ value }) => {
  return <span>{value}</span>;
};

export default TextCell;
